import React, { useRef, useState, useEffect } from 'react';
import { LAYOUT_PRESETS } from './graph-adapter';
import styles from './graph.module.css';

const presetKeys = Object.keys(LAYOUT_PRESETS);

/**
 * LayoutSwitcher — a small floating toolbar that lets the user
 * pick a Cytoscape layout algorithm and re-run the layout.
 */
export default function LayoutSwitcher({ onLayoutChange, activeLayout = 'targetRadial' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className={styles.layout_container} ref={ref}>
      <div
        className={styles.layout_button}
        onClick={() => setOpen((v) => !v)}
        title="Change graph layout"
      >
        <span style={{ fontSize: 14 }}>
          {LAYOUT_PRESETS[activeLayout]?.icon || '⚡'}
        </span>
      </div>

      {open && (
        <div className={styles.layout_dropdown}>
          {presetKeys.map((key) => {
            const preset = LAYOUT_PRESETS[key];
            const isActive = key === activeLayout;
            return (
              <div
                key={key}
                className={`${styles.layout_option} ${isActive ? styles.layout_option_active : ''}`}
                onClick={() => {
                  onLayoutChange(key);
                  setOpen(false);
                }}
              >
                <span>{preset.icon}</span>
                <span>{preset.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
